<!-- Main content -->
<section class='content'>
  <div class='container-fluid'>
    <div class='row'>
      <div class='col-lg-12 col-12'>
        <form [formGroup]='editGroupForm' (ngSubmit)='onSubmit()' *ngIf='group || !editMode' autocomplete='off'>
          <div class='row'>
            <div class='col-lg-12 col-12'>
              <div class='card card-primary'>
                <img [src]="'assets/img/volunteer-groups.jpg'" class="card-img-top" style='width: 100%;height: 180px;object-fit: cover;'>
                <div class="card-img-overlay">
                  <div class='row'>
                    <div class='col-lg-6 col-8'>
                      <h1 class='m-0 text-light' style='text-shadow: 2px 2px 8px black'>{{ editMode ? 'Edit Volunteer Group' : 'Add Volunteer Group' }}</h1>
                    </div>
                    <div class='col-lg-6 col-4'>
                      <button type="button" class="btn btn-light fa-pull-right" title="Remove" (click)='onClose()'>
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <div class='d-none d-sm-block'>
                    <ol class='breadcrumb float-sm-left'>
                      <li class='breadcrumb-item'><a [routerLink]="['/admin/dashboard']">Home</a></li>
                      <li class='breadcrumb-item'><a [routerLink]="['../']">Volunteer Groups</a></li>
                      <li class='breadcrumb-item active' *ngIf='editMode'>{{ group.vg_name }}</li>
                      <li class='breadcrumb-item active'>{{ editMode ? 'Edit' : 'Add Volunteer Group' }}</li>
                    </ol>
                  </div>
                </div>
                <div class='card-body' style='display: block;'>
                  <h5>Basic Details</h5>
                  <div class='row'>
                    <div class='col-lg-6 col-12'>
                      <div class='form-group'>
                        <label for='vg_name'>Group Name <span style='color: red'>*</span></label>
                        <input type='text' id='vg_name' formControlName='vg_name' class='form-control'>
                      </div>
                    </div>
                    <div class='col-lg-6 col-12'>
                      <div class='form-group'>
                        <label for='vg_leader'>Coordinator <span style='color: red'>*</span></label>
                        <select class='custom-select' id='vg_leader' formControlName='vg_leader'>
                          <option value='' disabled>Choose an option</option>
                          <option *ngFor='let leader of availableLeaders'
                                  [ngValue]='leader.user_id'>{{leader.user_name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class='col-lg-12 col-12'>
                      <div class='form-group'>
                        <label for='vg_desc'>Description <span style='color: red'>*</span></label>
                        <input type='text' id='vg_desc' formControlName='vg_desc' class='form-control'>
                      </div>
                    </div>
                  </div>
                  <div class='alert alert-default-info' *ngIf='!editGroupForm.valid'>
                    Form is not valid. Please check the form before saving.
                  </div>
                  <div class='alert alert-default-info' *ngIf='editGroupForm.valid && !editGroupForm.dirty'>
                    There are no changes made yet.
                  </div>
                  <button type='button' class='btn btn-primary' style='z-index: 20; position: relative' (click)='onClose()'>Go Back</button>
                  <div class='row fa-pull-right'>
                    <div class='col-lg-6 col-6'>
                      <app-button
                        [type]="'submit'"
                        [block]='false'
                        [color]="'success'"
                        [loading]='isUpdateLoading'
                        [disabled]='!editGroupForm.valid || !editGroupForm.dirty'>
                        Save
                      </app-button>
                    </div>
                  </div>
                  <!-- /.card-body -->
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class='col-lg-12 col-12' *ngIf='editMode'>
        <div class='card'>
          <div class='card-body'>
            <h5>Assigned Users</h5>
            <table class="table" *ngIf='assignedUsers.length > 0'>
              <thead>
              <tr>
                <th style="width: 10px">#</th>
                <th>Name</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor='let user of assignedUsers; let i = index'>
                <td>{{ i + 1 }}.</td>
                <td><a [routerLink]="['/admin/user-management/'+ user.user_id]">{{ user.user_name }}</a></td>
              </tr>
              </tbody>
            </table>
            <div style="text-align: center;" *ngIf='assignedUsers.length == 0'>
              <img [src]="'assets/img/noresfound.gif'" height="80" class="mb-2" alt="" loading="lazy">
              <h5>No users assigned or you don't have access to this resource</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main row -->
</section>
<!-- /.content -->

